import { css } from 'lit';

export default css`
  :host {
    --_background: var(--sl-body-background);

    background: var(--_background);
    display: block;
  }
`;
